import { getConfig } from "../utils/getConfig";
import {
  configMapping as staticConfigMapping,
  subdomainEmail as staticSubdomainEmail,
  subdomainToConfig as staticSubdomainToConfig,
} from "./config";

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  return hostname.split(".")[0];
};

/**
 * Fetches config from n8n; on failure returns static config from config.js.
 * n8n returns the resolved config directly for the current subdomain.
 * @returns {Promise<{
 *   id: string,
 *   requiredFields: string[],
 *   itemPriceFieldTTC: string,
 *   itemPriceFieldHT: string,
 *   deliveryCost: number,
 *   deliveryFreeThreshold: number,
 *   discount?: number,
 *   partnerEmail: string|null,
 *   partnerCommissionRate?: number,
 *   partnerCommissionPercent?: number,
 *   applyDeliveryFee?: boolean,
 *   applyPartnerDiscount?: boolean,
 *   showDeliveryFeeInSummary?: boolean,
 *   showPartnerDiscountInSummary?: boolean,
 *   noCheckout?: boolean,
 *   pricesOverride?: Record<string, number>,
 * }>}
 */
export const fetchConfig = async () => {
  try {
    const data = await getConfig();
    const { subdomainEmail, ...rest } = data.partnerConfig ?? data;
    return { ...rest, partnerEmail: subdomainEmail ?? null };
  } catch {
    const subdomain = getSubdomain();
    const configKey = staticSubdomainToConfig[subdomain] || "version4";
    const baseConfig = staticConfigMapping[configKey];
    const email = staticSubdomainEmail?.[subdomain] ?? null;
    return { ...baseConfig, partnerEmail: email };
  }
};
